<script>
  import { cart } from "$lib/state/cart";
  import { cartTotals } from "$lib/state/cartTotals";
  import { DELETE_ITEM_FROM_CART_EVENT, dispatchCustomEvent } from "$lib/utils/events";
  import { parsePrice } from "$lib/utils/parsePrice";
  import { onMount } from "svelte";
  import ShoppingQtyHandle from "./ShoppingQtyHandle.svelte";
  import ImageProduct from "../products/ImageProduct.svelte";
  import { klaviyoDeleteProduct } from "$lib/utils/KlaviyoEvents";

  /**@type {import ('$lib/types').MagentoCartItem}*/
  export let item;
  let isDelete = false;
  let noDelete = false;
  async function removeItem() {
    isDelete = true;
    try {
      const responseStream = await fetch(`/cart?itemId=${item.item_id}`, {
        method: "DELETE",
      });
      const response = await responseStream.json();
      klaviyoDeleteProduct(item, item.qty);
      if (responseStream.status == 200) {
        dispatchCustomEvent(DELETE_ITEM_FROM_CART_EVENT, $cart, item.item_id);
        cart.set(response.cart);
        cartTotals.set(response.cartTotals);
        isDelete = false;
        return;
      } else {
        noDelete = true;
      }

      throw new Error(/** @type {any} */ (response));
    } catch (error) {
      console.error(error);
    }
  }
  let qty = 1;
  /**@type {boolean}*/
  export let isCartPage = false;

  onMount(() => {
    item;
    qty = item.qty;
  });
</script>

<li class:longArrow={isCartPage} class:deleteAnimation={isDelete}>
  <div class="image">
    <ImageProduct
      productImage={item.images?.image}
      width={isCartPage ? "360" : "60"}
      alt={item.name}
    />
  </div>
  <div class="information">
    <p class="name">{item.name}</p>
    <div class="price-container">
      <ShoppingQtyHandle
        sku={item.sku}
        itemId={item.item_id}
        size={isCartPage ? "max" : "min"}
        bind:qty
      />

      <p class="price">{parsePrice("GBP", "en-gb", item.price)}</p>
    </div>
    <button class="delete" on:click={removeItem}>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18">
        <path
          d="M9.547,23.585a1.46,1.46,0,0,1-1.067-.453,1.49,1.49,0,0,1-.453-1.093V7.532H6.933v-1.2h4.56V5.585h6.88v.747h4.56v1.2H21.84V22.039a1.49,1.49,0,0,1-.453,1.093,1.46,1.46,0,0,1-1.067.453ZM20.64,7.532H9.227V22.039a.342.342,0,0,0,.093.253.309.309,0,0,0,.227.093H20.32a.307.307,0,0,0,.213-.107.332.332,0,0,0,.107-.24ZM12.293,20.119H13.52V9.772H12.293Zm4.053,0h1.227V9.772H16.347ZM9.227,7.532v0Z"
          transform="translate(-6.933 -5.585)"
          fill="var(--red)"
          stroke="var(--red)"
          stroke-width="0.5"
        />
      </svg>
    </button>
  </div>
</li>

<style>
  li {
    display: grid;
    grid-template-columns: 1fr 5fr;
    border-radius: 1rem;
    align-items: center;
  }
  .longArrow {
    border: 0.3rem solid var(--orange);
    padding: 2rem;
    aspect-ratio: 5/1;
  }
  .deleteAnimation {
    animation: delete 500ms ease forwards;
  }
  @keyframes delete {
    0% {
      transform: translateX(0);
      opacity: 1;
      display: initial;
    }
    80% {
      transform: translateX(100%);
      opacity: 0;
    }
    100% {
      transform: translateX(100%);
      opacity: 0;
      display: none;
    }
  }
  .image {
    width: 9rem;
    height: 9rem;
    aspect-ratio: 1/1;
  }
  .longArrow .image {
    width: 20rem;
    height: 20rem;
  }
  .information {
    height: 6rem;
    display: grid;
    grid-template-columns: 5fr 1fr;
    grid-template-rows: 1fr 1fr;
    align-items: center;
    justify-content: space-between;
    gap: 1.5rem;
  }
  .information p {
    font-size: 1.8rem;
    line-height: 1;
  }
  .longArrow .information p {
    font-size: 2.4rem;
  }
  .information .name {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    line-height: 1;
    -webkit-box-orient: vertical;
    box-orient: vertical;
    overflow: hidden;
  }
  .price-container {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
  .price-container .price {
    font-size: 2rem;
    font-weight: 700;
    color: var(--orange);
  }
  .delete {
    width: 2.5rem;
    height: 2.5rem;
    cursor: pointer;
    background: none;
    border: none;
    grid-column: -1/2;
    grid-row: 1/2;
  }
  @media (max-width: 580px) {
    .longArrow {
      padding: 3rem 0;
      grid-template-columns: 1fr 3fr;
    }
    .longArrow .image {
      width: 100%;
      height: 100%;
      aspect-ratio: 1/1;
      min-width: 8rem;
    }
  }
</style>
